import { render } from "./layout-schedule-v2.vue?vue&type=template&id=18bb037c&ts=true"
import script from "./layout-schedule-v2.vue?vue&type=script&lang=ts"
export * from "./layout-schedule-v2.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__